/* src/app/navigation/components/wg-header/wg-header.component.css */
:host {
  display: block;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 1.5;
  color: #334155;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
:host a,
:host button {
  all: unset;
  box-sizing: border-box;
  cursor: pointer;
}
:host header,
:host h1,
:host p,
:host div,
:host span:not(.material-symbols-outlined) {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: inherit;
  font-family: inherit;
  font-weight: normal;
  font-style: normal;
  line-height: inherit;
  text-transform: none;
  letter-spacing: normal;
  color: inherit;
  text-decoration: none;
  box-sizing: border-box;
}
:host header {
  position: relative !important;
  left: auto !important;
  right: auto !important;
  width: auto !important;
  min-width: 0 !important;
  height: auto !important;
  background-color: transparent !important;
  border-bottom: none !important;
  z-index: auto;
}
:host header a,
:host header a:link,
:host header a:visited,
:host header a:hover,
:host header a:active {
  color: inherit !important;
}
:host h1,
:host p {
  display: block;
}
/*# sourceMappingURL=wg-header.component.css.map */
